import { Component, Input, OnChanges, SimpleChanges, input } from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

type ProcessView = stages.process.ProcessView;

@Component({
	selector: "stages-navigation-entry-two-line-split-rating",
	templateUrl: "./two-line-split-rating-navigation-entry.component.html",
	styleUrls: ["./two-line-split-rating-navigation-entry.component.scss"],
	imports: [NgClass, TranslateModule],
})
export class TwoLineSplitRatingNavigationEntryComponent implements OnChanges {
	private readonly CSS_BY_RATING: StringToString = {
		NOT_RATED: "rating-not-rated",
		NONE: "rating-none",
		INCOMPLETE: "rating-incomplete",
		FAIR: "rating-fair",
		COMPLETE: "rating-complete",
	};

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	entry!: TwoLineEntry;

	readonly mode = input.required<NAV_ENTRY_DISPLAY_MODE>();

	iconClass!: string;

	ngOnChanges(changes: SimpleChanges): void {
		this.iconClass = changes.entry && this.entry.original ? this.getIconClass(this.entry.original) : "";
	}

	private getIconClass(element: ProcessView): string {
		const ratingContainer = element.complianceRatingContainer;
		if (ratingContainer) {
			const rating = ratingContainer.rating.rating;
			if (rating && this.CSS_BY_RATING[rating]) {
				return this.CSS_BY_RATING[rating];
			}
		}
		return "";
	}
}
